import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { List, Set } from 'immutable';
import { Router } from '@angular/router';
import { EventListStore } from '../service/event-list.store';
import { OnyxSummaryEvent } from '../models/event.summary';
import { MenuStore } from '../../menus/service/menu.store';
import { EnvironmentConfiguration } from '../../environment/services/environment.configuration';
import { EventSearchParametersStore } from '../service/event-search-parameters.store';
import { EventSearchFilter } from '../models/event-filter';
import { LogService } from '../../shared/log/log.service';
import { EventFilterType } from '../models/event-filter-type-enum';
import { EventFilterUtilsService } from '../service/event-filter-util-service';
import { FlashMessagesService } from '../../shared/flash-messages/service/flash.messages.service';
import { EventSearchFilterValidator } from '../../menus/event-search-filter/event-search-filter.validator';
import { FormGroup } from '@angular/forms';
import { EventSearchFormsStore } from '../service/event-search-forms.store';
import { EventSearchText } from '../models/event-search-text';

@Component({
  selector: 'pioneer-event-list',
  templateUrl: './event-list.component.html'
})
export class EventListComponent implements OnInit {

  private data: Observable<List<OnyxSummaryEvent>>;

  public eventSearchTextForm: FormGroup;

  constructor(private eventListStore: EventListStore,
              private environment: EnvironmentConfiguration,
              private router: Router,
              private menuStore: MenuStore,
              private logger: LogService,
              private flashMessagesService: FlashMessagesService,
              private eventSearchParametersStore: EventSearchParametersStore,
              private eventFilterUtils: EventFilterUtilsService,
              private eventSearchFormsStore: EventSearchFormsStore) {
  }

  ngOnInit() {
    this.data = this.eventListStore.events;
    this.menuStore.setPageTitle('EVENTS.TITLE');
    this.eventSearchFormsStore.populateSearchTextForm('');
    this.eventSearchTextForm = this.eventSearchFormsStore.searchTextForm;
  }

  get events(): Observable<List<OnyxSummaryEvent>> {
    return this.data;
  }

  get searchTextSet(): Observable<Set<string>> {
    return this.eventSearchParametersStore.searchTextSet;
  }

  get searchFilterSet(): Observable<Set<EventSearchFilter>> {
    return this.eventSearchParametersStore.searchFilterSet;
  }

  get eventCount(): Observable<number> {
    return this.eventListStore.totalEventCount;
  }

  get eventCountForTranslate(): Observable<Object> {
    return this.eventCount.map(count => {
      return {
        eventCount: count
      };
    });
  }

  get eventsAboveMax(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > this.maxEvents;
    });
  }

  get eventsPresent(): Observable<boolean> {
    return this.eventCount.map(eventCount => {
      return eventCount > 0;
    });
  }

  get maxEvents(): number {
    return this.environment.events.maxEvents;
  }

  get maxEventsForTranslate(): Object {
    return {
      maxEvents: this.maxEvents
    };
  }

  onSelect(event: OnyxSummaryEvent): void {
    this.router.navigate([ '/event', event.eventId ]);
  }

  onSubmit(models: any) {
    this.logger.info('onSubmit');
    this.addSearchText(models);
    return false;
  }

  resetSearch(): void {
    this.eventSearchParametersStore.reset(true);
    this.eventSearchFormsStore.populateSearchTextForm('');
  }

  addSearchText(models: any): void {
    this.logger.info(`addSearchText: ${JSON.stringify(models)}`);

    const eventSearchText = new EventSearchText(models);

    if (!eventSearchText.searchText) {
      return;
    }

    const filterErrors = this.eventSearchFormsStore.filterMenuErrorsSnapshot;

    if (filterErrors != null) {
      if (filterErrors[EventSearchFilterValidator.DATE_ERROR]) {
        this.flashMessagesService.error('MESSAGES.ERROR.INVALID_DATE_RANGE');
      }

      if (filterErrors[EventSearchFilterValidator.PAYMENT_STATUS_ERROR]) {
        this.flashMessagesService.error('MESSAGES.ERROR.NO_PAYMENT_STATUS_SELECTED');
      }

      return;
    }

    this.eventSearchFormsStore.searchFromSearchText(eventSearchText);
  }

  addSearchFilter(filterField: string, filterValue: string): void {
    this.eventSearchParametersStore.addSearchFilter(filterField, filterValue);
    this.eventSearchParametersStore.updateUrl();
  }

  removeSearchText(event: Event): void {
    const element: Element = <Element>(event.target || event.srcElement);
    const searchText = element.innerHTML.trim();
    this.eventSearchParametersStore.removeSearchText(searchText, true);
  }

  get isDefaultViewSelected(): Observable<boolean> {
    return this.eventSearchParametersStore.isDefaultViewSelected;
  }

  updateToDefaultURL(): void {
    this.eventSearchParametersStore.defaultViewUrl();
  }

  updateToFinancialURL(): void {
    this.eventSearchParametersStore.financialViewUrl();
  }

  removeSearchFilter(event: Event, filter: EventSearchFilter): void {
    this.eventSearchParametersStore.removeSearchFilter(filter, true);
    const element: Element = <Element>(event.target || event.srcElement);
    element.innerHTML.trim();
  }

  getTokenFilterFieldTranslationKey(filterField: string) {
    switch (filterField) {
      case EventFilterType.COMPLETED.toString():
      case EventFilterType.MISSING_AGENCY.toString():
        return 'EVENTS.FILTER_LABEL.EVENT_STATUS';
      default:
        return 'EVENTS.FILTER_LABEL.' + filterField;
    }
  }

  getTokenValue(filter: EventSearchFilter): string {
    return this.eventFilterUtils.getTokenDisplayString(filter);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/event-list/event-list.component.ts